const handleTokenError = (tokenError) => {
    switch (tokenError.error) {
        case 'invalid_request':
        case 'invalid_client':
        case 'unauthorized_client':
        case 'unsupported_grant_type':
        case 'invalid_scope':
            return {
                error: 'client_error',
                error_description: JSON.stringify(tokenError),
            };
        case 'invalid_grant':
            return {
                error: 'login_required',
                error_description: `Token request failed with ${JSON.stringify(tokenError)}`,
            };
        default:
            return {
                error: 'unknown_error',
            };
    }
};
export default handleTokenError;
//# sourceMappingURL=handleTokenError.js.map